import { render, staticRenderFns } from "./FooterPaginationComponent.vue?vue&type=template&id=30305794&"
import script from "./FooterPaginationComponent.vue?vue&type=script&lang=js&"
export * from "./FooterPaginationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports